import React from 'react';

import { DEFAULT_PORTFOLIO_NAME } from '@scripts/utilities/constants.js'
import { formatPortfolio } from './formatPortfolio.js';

import { ColumnHeaderSortable } from '../../../DataTable/index.jsx';

import Column from './base.jsx';

var columnOptions = {
  id: 'col-portfolio',
  title: 'Portfolio'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }
}


class DetailColumn extends React.Component {
  render() {
    const standardPortfolio = formatPortfolio(this.props.row);
    return (
      <td>
        <a  style={{ cursor: 'pointer' }} onClick={() => this.props.row.selectPortfolio(standardPortfolio)}>{this.props.row.name || DEFAULT_PORTFOLIO_NAME}</a>
      </td>
    );
  }
}


class PortfolioName extends Column {
  get id() {
    return columnOptions.id;
  }

  /**
   * This column must always be displayed
   */
  get isConfigurable() {
    return false;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PortfolioName;

